module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_footer_modernmind-f10556ff6a4642c86ec6b7c6ecfa236d.svg";